import { gql, useQuery } from "@apollo/client";
const ItemInfo = {
	_id: String,
	name: String,
	ref: String,
	count: Number,
	brand: String,
};
export const Machine = gql`
	query getMachine($id: String!) {
		machine(id: $id) {
			_id
			name
			ref
			photo
			items
			itemsInfo {
				_id
				name
				ref
				count
				brand
			}
			documents
			documentsInfo {
				data
				public
				expirationDate
			}
			serialNumber
			category
			status
			pin
		}
	}
`;
